import DataTable_ from "common/DataTable";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAll, postData } from "utils/queries";
import styles from "./details.module.css";
import { formatDateFromDateAndTime } from "utils";
import SaveButton from "components/SaveButton";
import Button from "common/Button";
import { format, formatDistanceToNow } from "date-fns";
import ContainerHeader from "common/ContainerHeader";

const OrderDetails = () => {
  const [data, setData] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();

  const fetchOrders = async () => {
    try {
      const result = await getAll(`orders/order/${id}`);
      console.log("result is", result?.data?.order);
      setData(result?.data?.order);
    } catch (error) {}
  };

  useEffect(() => {
    if (id) {
      fetchOrders();
    }
  }, [id]);
  const columns = [
    // {
    //     name: 'Event',
    //     selector: row => row.event_name,
    //     windth:"fit-content"
    // },
    // {
    //   name: "Ticket",
    //   selector: (row) => row.item_name,
    //   windth: "fit-content",
    // },
    {
      name: "Ticket",
      selector: (row) =>
        row.variant_name && row.variant_name !== row.item_name
          ? `${row.item_name} (${row.variant_name})`
          : row.item_name,
      windth: "fit-content",
    },
    {
      name: "Price",
      selector: (row) =>`£ ${row.base_price || row.price}`,
      windth: "fit-content",
    },
    {
      name: "Fees",
      selector: (row) => `£ ${row.booking_fee || 0}`,
      windth: "fit-content",
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity,
      windth: "fit-content",
    },
    {
      name: "Total",
      selector: (row) =>`£ ${ row.price * row.quantity}`,
      windth: "fit-content",
    },
    {
      name: "Discounted Total",
      selector: (row) =>
        row.discount_percentage
          ? row.price * row.quantity * (1 - row.discount_percentage / 100)
          : "-",
      windth: "fit-content",
    },
    // {
    //     name: 'Payment Status',
    //     selector: row => row.payment_status,
    //     windth:"fit-content"

    // }
  ];

  const initiateRefund = async () => {
    try {
      const result = await postData(`request_refund/initiate`, {
        order_id: data?.[0]?.order_id,
        reason: "",
      });
      fetchOrders();
    } catch (error) {}
  };

  const orderOne = data?.[0];

  const firstButtonArgs = {
    label: "Refund",
    id: "refund",
    type: "button",
    buttonOverrideInlineStyle: { marginRight: "1.6rem" },
    onClick: () => {
      initiateRefund();
    },
  };

  const secondButtonArgs = {
    label: "Download",
    id: "download",
    type: "submit",
    onClick: () => {},
  };

  const convertDateTimeFormat = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    // Format as "Wed 10th May 2023"
    const formattedDate = format(date, "EEE do MMM yyyy");

    // Calculate relative time (e.g., "2 years ago")
    const relativeTime = formatDistanceToNow(date, { addSuffix: true });

    return `${formattedDate} (${relativeTime})`;
  };

  const formatPaymentPlan = (plan) => {
    if (!plan || plan === "full") return "";
    const parts = plan.split("_");
    if (parts.length < 2) return "";
    return `${parts[1]} months`;
  };

  return (
    <>
      <ContainerHeader
        label="Orders"
        showAddButton={false}
        showBackButton
        onBackClick={() => navigate(-1)}
      />
      <div>
        <div className={styles.userInfo}>
          <span className={styles.name}>{`${orderOne?.name}`} </span>
          <span className={styles.details}>{`(${
            orderOne?.email
          }), ${convertDateTimeFormat(orderOne?.created_at)}`}</span>
        </div>
        <div className={styles.orderInfo}>
          {/* Date + Event Name */}
          <span className={styles.eventDetails}>
            {formatDateFromDateAndTime(orderOne?.created_at)} -{" "}
            {orderOne?.ticket_name} : {orderOne?.event_name}
          </span>
          <br />
          <br />
          {/* Location */}
          <span className={styles.location}>
            {orderOne?.venue}
          </span>
          <br />
          <br />
          {/* Reference ID */}
          <span className={styles.reference}>
            Reference - {orderOne?.order_id}
          </span>
          <br />
          <br />
          {/* Payment Method */}
          <span className={styles.paymentMethod}>
            Payment Method - {orderOne?.payment_method}
          </span>
          {formatPaymentPlan(orderOne?.payment_plan) && (
            <>
              <br />
              <br />
              <span className={styles.paymentMethod}>
                Payment Plan - {formatPaymentPlan(orderOne.payment_plan)}
              </span>
            </>
          )}
          {orderOne?.completed_on && (
            <>
              <br />
              <br />
              <span className={styles.paymentMethod}>
                Completed On - {convertDateTimeFormat(orderOne.completed_on)}
              </span>
            </>
          )}
        </div>
      </div>
      {/* <Button label={"Re-send"} /> */}
      <div style={{ height: "2rem" }}></div>
      <DataTable_ data={data} columns={columns} pagination={false} />

      {/* <SaveButton
        firstButtonArgs={firstButtonArgs}
        secondButtonArgs={secondButtonArgs}
      /> */}
    </>
  );
};

export default OrderDetails;
